import React, { useState, useEffect } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import InformacionVideo from './informacionVideo';
import InformacionImg from './informacionImg';
import Carta from './carta';
import { Container, Grid } from '@mui/material';
import ServicioDetalle, { TITULOS, tieneContenido } from './servicioDetalle';
import { getProductosImg } from '../consumos/img';
import { API_BASE } from '../variables/variablesConection';

const TabPanel = ({ children, value, index, ...other }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
};

export default function GoogleTabs({ linea, producto, ProductoDescripcion, Valor, Moneda, Impuesto, Cantidad, dtl, iva, descuento, servicio }) {
  const [valueShopi, setValueShopi] = useState(null);
  const [video, setVideo] = useState(false);
  const [value, setValue] = useState(0);
  const [imgdos, setImgdos] = useState(producto);

  // Imagenes/medios del producto via backendCotizaciones (proxy a Shopify).
  const getShopify = (dato) => {
    return fetch(`${API_BASE}/productos/${encodeURIComponent(dato)}/media`)
      .then((response) => response.text())
      .then((result) => {
        setValueShopi(result);
        return result;
      })
      .catch((error) => {
        console.error('Error Shopify:', error);
        return '{}';
      });
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (producto) {
      getShopify(producto).then((validar) => {
        try {
          const parsed = JSON.parse(validar);
          if (parsed?.data?.products?.edges?.length) {
            setVideo(true);
          }
        } catch (e) {
          // respuesta no valida: se ignora
        }
      });
      getProductosImg(producto).then((item) => setImgdos(item));
    }
  }, [producto]);

  const shopiObj = valueShopi ? JSON.parse(valueShopi) : {};

  // Pestanas dinamicas: se construyen segun el contenido disponible para evitar
  // desalineacion entre el indice de la pestana y su panel.
  const panes = [
    {
      label: 'Información general',
      content: (
        <>
          <Carta
            linea={linea} producto={producto} ProductoDescripcion={ProductoDescripcion}
            dtl={dtl} descuento={descuento} iva={iva} Valor={Valor} Moneda={Moneda}
            Impuesto={Impuesto} Cantidad={Cantidad} valueShopi={shopiObj} img2={imgdos}
          />
          {video ? <InformacionVideo valueShopi={shopiObj} /> : ''}
        </>
      ),
    },
  ];

  if (!ProductoDescripcion.includes('SERVICIO')) {
    panes.push({
      label: 'Ficha técnica',
      content: (
        <div className="box">
          <InformacionImg producto={producto} ProductoDescripcion={ProductoDescripcion} valueShopi={shopiObj} />
        </div>
      ),
    });
  }

  if (tieneContenido(servicio)) {
    panes.push({
      label: TITULOS[servicio.tipo] || 'Servicio',
      content: (
        <div className="box">
          <ServicioDetalle servicio={servicio} />
        </div>
      ),
    });
  }

  return (
    <Container sx={{ padding: 0 }}>
      <Grid container>
        <Grid item xs={12}>
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            aria-label="pestañas del producto"
          >
            {panes.map((p, i) => (
              <Tab key={i} label={p.label} />
            ))}
          </Tabs>
        </Grid>
        <Grid item xs={12}>
          {panes.map((p, i) => (
            <TabPanel key={i} value={value} index={i}>
              {p.content}
            </TabPanel>
          ))}
        </Grid>
      </Grid>
    </Container>
  );
}
